import { ParseKeys } from 'i18next'
import { useTranslation } from 'react-i18next'

type FormHeaderProps = {
  title: ParseKeys
}
export function FormHeader({ title }: FormHeaderProps) {
  const { t } = useTranslation()

  return <div style={{ fontSize: '18px', fontWeight: 500 }}>{t(title)}</div>
}
